var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-view" }, [
    _c("div", { staticClass: "tag hide-scroll" }, [
      _c("h4", { staticClass: "tag__title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.i18nFieldValue(_vm.displayTag, "name")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm.collectionName
        ? _c("h5", { staticClass: "tag__title" }, [
            _vm._v("\n      " + _vm._s(_vm.collectionName) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "tag__photo" }, [
        _vm.isDisplayTagArViewButtonVisible
          ? _c(
              "button",
              {
                ref: "displayTagTooltipButton",
                staticClass: "arview-button",
                on: {
                  mouseenter: _vm.showDisplayTagViewIn3DTooltip,
                  mouseleave: _vm.hideDisplayTagViewIn3DTooltip,
                  click: function ($event) {
                    return _vm.showArView(_vm.displayTag)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/armaker/arview-cube.png"),
                  },
                }),
                _vm._v(" "),
                _vm.isDisplayTagViewIn3DTooltipVisible
                  ? _c("div", { staticClass: "tooltip" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("viewIn3D")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          attrs: { src: _vm.displayTag.images[0] },
          on: {
            contextmenu: function ($event) {
              $event.preventDefault()
              return _vm.rightClickBlock.apply(null, arguments)
            },
            click: function ($event) {
              return _vm.$emit("preview", _vm.selectedIndex)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("pre", { staticClass: "tag__description" }, [
        _vm._v(_vm._s(_vm.i18nFieldValue(_vm.displayTag, "description"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tag__action" },
        [
          (_vm.isJoorActionTag(_vm.displayTag) && _vm.isInJoorPlatform) ||
          !_vm.isJoorActionTag(_vm.displayTag)
            ? [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.displayTag.actionLink,
                        expression: "displayTag.actionLink",
                      },
                    ],
                    staticClass: "cta-btn overflow-ellipsis",
                    attrs: { title: _vm.getActionMutate(_vm.displayTag) },
                    on: {
                      click: function ($event) {
                        return _vm.handleActionClick(_vm.displayTag)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getActionMutate(_vm.displayTag)) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isJoorActionTag(_vm.displayTag) && _vm.isInJoorPlatform
            ? [
                _c("span", { staticClass: "overflow-ellipsis" }, [
                  _vm._v(_vm._s(_vm.findWholesalePrice(_vm.displayTag))),
                ]),
              ]
            : [
                !_vm.isJoorActionTag(_vm.displayTag)
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "overflow-ellipsis",
                          attrs: {
                            title: _vm.i18nFieldValue(_vm.displayTag, "price"),
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.i18nFieldValue(_vm.displayTag, "price"))
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gallery" },
      _vm._l(_vm.tags, function (tag, index) {
        return _c(
          "div",
          {
            key: tag.objectId,
            staticClass: "gallery__item",
            on: {
              click: function ($event) {
                _vm.selectedIndex = index
              },
            },
          },
          [
            _c("img", {
              staticClass: "gallery__photo",
              attrs: { src: tag.images[0] },
              on: {
                contextmenu: function ($event) {
                  $event.preventDefault()
                  return _vm.rightClickBlock.apply(null, arguments)
                },
              },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }